<template>
  <base-view edition="2023" />
</template>

<script>
import BaseView from "@/views/BaseView";

export default {
  components: {
    BaseView,
  },
};
</script>
